module.exports = __webpack_public_path__ + "static/media/logo-modal.29a0fb30.png";